import styled from 'styled-components'
import { NEUTRAL_300, NEUTRAL_100, ORANGE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    gap: 6px;
` as any

export const Divider = styled.div`
    height: 1px;
    background-color: ${NEUTRAL_100};
    width: 100%;
` as any

export const HelpText = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${INTER.semiBold};
    font-size: 13px;
    color: ${NEUTRAL_300};
    white-space: nowrap;
    padding: 0;
` as any

export const ContactText = styled.span`
    display: flex;
    font-family: ${INTER.semiBold};
    font-size: 13px;
    align-items: center;
    justify-content: center;
    color: ${ORANGE};
    white-space: nowrap;
    padding: 0;
    cursor: pointer;
` as any
